import { Component, CUSTOM_ELEMENTS_SCHEMA, Input } from '@angular/core';
import { WorkOrderSearchTextForm } from '../../../form-model/work-order-search-text.form.model';
import { FormBuilder, FormControl, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { utils } from '../../../helper/utils';

import { RouterModule } from '@angular/router';
import '@maersk-global/mds-components-core/mc-input-group';
import '@maersk-global/mds-components-core/mc-input';
import '@maersk-global/mds-components-core/mc-button';

@Component({
  selector: 'app-search',
  imports: [FormsModule, ReactiveFormsModule, RouterModule],
  templateUrl: './search.component.html',
  styleUrl: './search.component.scss',
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class SearchComponent {
  @Input({ required: true }) workOrderSearchTextForm!: FormGroup<WorkOrderSearchTextForm>;

  applySearchTextFilters() {
    this.workOrderSearchTextForm.controls.appliedWOSearchTextFilter.setValue(true);
  }
  constructor(private formBuilder: FormBuilder) {}

  ngOnInit() {
    utils.setupWorkOrderSearchControls(this.formBuilder, this.workOrderSearchTextForm);
  }

  isControlInErrorState(control: FormControl): boolean | null {
    return utils.isControlInErrorState(control);
  }
}
